// client/extensions/Highlight.ts
import { DesignSystem } from "@adornis/chemistry/elements/theming/design.js";
import { mergeAttributes } from "@tiptap/core";
import TiptapHighlight from "@tiptap/extension-highlight";
var HighlightTranslations = {
  highlight: {
    tooltipHighlight: ["Text Markieren", "Highlight text"],
    tooltipHighlightError: ["Fehler Markieren", "Highlight error"],
    tooltipHighlightRemove: ["Markierung entfernen", "Remove highlight"]
  }
};
var Highlight = {
  buttons: ({ editor, host }) => [
    {
      name: "toggleHighlightError",
      icon: "ink_highlighter",
      color: DesignSystem.currentTheme.getValue()?.colors.tone.error?.string,
      background: "black",
      action: () => editor.chain().focus().toggleHighlight({ color: DesignSystem.currentTheme.getValue()?.colors.tone.error?.string ?? "" }).run(),
      tooltip: host.translator.translate("tiptap", "highlight", "tooltipHighlightError")
    },
    {
      name: "toggleHighlightAccent",
      icon: "ink_highlighter",
      color: DesignSystem.currentTheme.getValue()?.colors.accent.string,
      background: "black",
      action: () => editor.chain().focus().toggleHighlight({ color: DesignSystem.currentTheme.getValue()?.colors.accent.string }).run(),
      tooltip: host.translator.translate("tiptap", "highlight", "tooltipHighlight")
    }
  ],
  extensions: [
    TiptapHighlight.extend({
      addOptions() {
        return {
          multicolor: true,
          HTMLAttributes: {}
        };
      },
      parseHTML() {
        return [{ tag: "x-highlight" }, { tag: `${DesignSystem.prefix}-highlight` }];
      },
      renderHTML({ mark, HTMLAttributes }) {
        return [
          `${DesignSystem.prefix}-highlight`,
          mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, { style: `color: ${mark.attrs.color}` }),
          0
        ];
      },
      addAttributes() {
        if (!this.options.multicolor) {
          return {};
        }
        return {
          color: {
            default: null,
            parseHTML: (element) => element.getAttribute("data-color") || element.style.backgroundColor,
            renderHTML: (attributes) => {
              if (!attributes.color) {
                return {};
              }
              return {
                "data-color": attributes.color.string,
                style: `color: ${attributes.color.string}`
              };
            }
          }
        };
      }
    })
  ]
};
export {
  Highlight,
  HighlightTranslations
};
